<template>
  <div class="row">
 <div class="col-md-12">
   <h3>iKids List</h3>
   <hr>
   <div class="form-inline">
     <label class="mr-2">Filter Status</label>
     <select
       class="form-control"
       v-model="meta.checkin_status"
       @change="loadStatus"
     >
       <option value="0">Show All</option>
       <option value="1">Check In</option>
       <option value="2">In Class</option>
       <option value="3">Queued</option>
       <option value="4">Check Out</option>
     </select>
   </div>
   <div class="clearfix"><br /></div>
 </div>
 <!-- <div class="form-inline" v-if="meta.is_active">
     <label class="mr-2">Filter Status</label>
     <select
       class="form-control"
       v-model="meta.is_active"
       @change="loadIsActive"
     >
       <option value="2">Show All</option>
       <option value="1">Show Only Active</option>
       <option value="0">Show Only Inactive</option>
     </select>
   </div> -->
 <div class="col-md-12">
        <div class="form-inline">
            <label class="mr-3">Filter Class</label>
            <select class="form-control" v-model="meta.ikid_class_name" @change="loadClassFilter">
                <option value="0">Show All</option>
                <option v-for="item in listclass" :key="item.id" :value="item.name">{{ item.name }}</option>
            </select>
        </div>
        <div class="clearfix"><br></div>
    </div>
 <div class="col-md-4 mb-2">
   <div class="form-inline">
     <label class="mr-2">Showing</label>
     <select
       class="form-control"
       v-model="meta.per_page"
       @change="loadPerPage"
     >
       <option value="10">10</option>
       <option value="25">25</option>
       <option value="50">50</option>
       <option value="100">100</option>
     </select>
     <label class="ml-2">Entries</label>
   </div>
 </div>

 <div class="col-md-4 offset-md-4">
   <!-- SEARCH BY DATE -->
   <div class="form-inline float-right" v-if="is_search_by_date">
     <label class="mr-2">Search by Date</label>
     <input type="date" class="form-control" @input="search" />
   </div>
   <!-- SEARCH DEFAULT -->
   <div class="form-inline float-right mb-3" v-else>
     <label class="mr-2 ">Search</label>
     <input type="text" class="form-control " @input="search" />
   </div>
 </div>

 <div class="col-md-12"  >
   <CDataTable

     sorter
     striped
     hover
     bordered
     :items="items"
     :fields="fields"
     :sort-by.sync="sortBy"
     :sort-desc.sync="sortDesc"
     show-empty
   >
     <!-- IKID REPORT -->
     <template #name="{item}">
       <td v-if="item.name">
         <router-link v-on:click.native="openURL(item.uuid)" to="/"
           ><b style="color:#007bff"> {{ item.name }}</b>
         </router-link>
       </td>
       <td v-else></td>
     </template>
     <template #class_name="{item}">
       <td v-if="item.class_name">{{ item.class_name }}</td>
       <td v-else></td>
     </template>
     <template #profilepic="{item}">
       <td>
         <img
           v-bind:src="getPhoto(item.get_photo)"
           width="100"
           height="110"
         />
       </td>
     </template>
     <template #dad="{item}">
       <td v-if="item.dad">
         {{ item.dad.firstname + " " + item.dad.lastname }}
       </td>
       <td v-else></td>
     </template>
     <template #mom="{item}">
       <td v-if="item.mom">
         {{ item.mom.firstname + " " + item.mom.lastname }}
       </td>
       <td v-else></td>
     </template>
     <template #is_active="{item}">
       <td>
         <CBadge v-if="item.is_active == 0" color="danger">No</CBadge>
         <CBadge v-if="item.is_active == 1" color="success">Yes</CBadge>
       </td>
     </template>
     <template #checkin_status="{item}">
       <td >
        <CBadge v-if="item.checkin_status !== null && item.checkin_status.action == 'check in'" color="info"> Ready For Checkin</CBadge>
        <CBadge v-if="item.checkin_status !== null && item.checkin_status.action == 'in class'" color="success">In Class </CBadge>
        <CBadge v-if="item.checkin_status !== null && item.checkin_status.action == 'queued'" color="success">In Queued </CBadge>
        <CBadge v-if="item.checkin_status !== null && item.checkin_status.action == 'check out'" color="info">Check Out</CBadge>

        <CBadge v-if="item.checkin_status == null" color="secondary"></CBadge>
       </td>
     </template>
     <template #action="{item}">
      <td v-if = "item.checkin_status == null || item.checkin_status.action == 'check out'" style="width:150px">
        <CButton block
           size="sm"
           variant="primary"
           color="success"
           class="ml-1"
           @click="is_uuid ? checkin(item.uuid) : checkin(item.id)"
           >Check In</CButton
        >
      </td>

      <td v-if = "item.checkin_status != null && item.checkin_status.action == 'check in'" style="width:150px">
        <CButton block
           size="sm"
           variant="primary"
           color="success"
           class="ml-1"
           @click="present(item.id)"
           >Present</CButton
        >
        <!-- <CButton
           size="sm"
           block
           variant="outline"
           color="secondary"
           class="ml-1"
           @click="cancelStatus(item.id, 1)"
           >Cancel</CButton
         > -->
      </td>

      <td v-if = "item.checkin_status != null && item.checkin_status.action == 'queued'" style="width:150px">
        <CButton block
           size="sm"
           variant="primary"
           color="danger"
           class="ml-1"
           @click="checkout(item.id)"
           >Check Out</CButton
        >
      </td>

      <td v-if = "item.checkin_status != null && item.checkin_status.action == 'in class'" style="width:150px">
        <CButton block
           size="sm"
           variant="primary"
           color="danger"
           class="ml-1"
           @click="forceCheckout(item.id)"
           >Check Out</CButton
        >
        <CButton
           size="sm"
           block
           variant="outline"
           color="secondary"
           class="ml-1"
           @click="forceCancelStatus(item.id, 2)"
           >Cancel</CButton
         >
         <CButton block
           size="sm"
           variant="outline"
           color="info"
           class="ml-1"
           @click="is_uuid ? reprint(item.uuid) : reprint(item.id)"
           >Reprint</CButton
        >
      </td>

       <!-- <td v-if="item.is_active == 1" style="width:150px">

        <CButton block
           size="sm"
           variant="primary"
           color="success"
           class="ml-1"
           @click="is_uuid ? checkin(item.uuid) : checkin(item.id)"
           >change</CButton
         >

         <CButton block
           v-if="item.checkin_status == null"
           size="sm"
           variant="primary"
           color="success"
           class="ml-1"
           @click="is_uuid ? checkin(item.uuid) : checkin(item.id)"
           >Check In</CButton
         >
         <CButton
           v-if="item.checkin_status !== null && item.checkin_status.action == 'check in'"
           block
           size="sm"
           variant="primary"
           color="warning"
           class="ml-1 m-1"
           @click=inclass(item.id)
           >Present</CButton
         >
         <CButton
           v-if="item.checkin_status !== null && item.checkin_status.action == 'check in'"
           block
           size="sm"
           variant="outline"
           color="secondary"
           class="ml-1 m-1"
           @click="is_uuid ? (item.uuid) : (item.id)"
           >Cancel</CButton
         >
         <CButton
           v-if="item.checkin_status !== null && item.checkin_status.action == 'queued'"
           size="sm"
           block
           variant="primary"
           color="danger"
           class="ml-1"
           @click="is_uuid ? checkout(item.uuid) : checkout(item.id)"
           >Check Out</CButton
         >
         <CButton
           v-if="item.checkin_status !== null && item.checkin_status.action == 'queued'"
           size="sm"
           block
           variant="outline"
           color="secondary"
           class="ml-1"
           @click="is_uuid ? (item.uuid) : (item.id)"
           >Cancel</CButton
         >
         <b v-if="item.checkin_status !== null && item.checkin_status.action == 'check out'">Already Attend</b>

       </td>

       <td v-if="item.is_active == 0" style="width:150px">
        <CButton block
           v-if="item.checkin_status == null"
           size="sm"
           variant="primary"
           color="success"
           class="ml-1"
           @click="is_uuid ? checkin(item.uuid) : checkin(item.id)"
           >Check In</CButton
         >
         <CButton
           v-if="item.checkin_status !== null && item.checkin_status.action == 'check in'"
           block
           size="sm"
           variant="primary"
           color="warning"
           class="ml-1 m-1"
           @click="is_uuid ? queue(item.uuid) : queue(item.id)"
           >To Queue</CButton
         >
         <CButton
           v-if="item.checkin_status !== null && item.checkin_status.action == 'queued'"
           size="sm"
           block
           variant="primary"
           color="danger"
           class="ml-1"
           @click="is_uuid ? checkout(item.uuid) : checkout(item.id)"
           >Check Out</CButton
         >
         <b v-if="item.checkin_status !== null && item.checkin_status.action == 'check out'">Already Attend</b>

       </td> -->

     </template>
   </CDataTable>
 </div>

 <div class="col-md-6">
   <p>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} items</p>
 </div>

 <div class="col-md-6">
   <b-pagination
     v-model="meta.current_page"
     :total-rows="meta.total"
     :per-page="meta.per_page"
     align="right"
     @change="changePage"
     aria-controls="dw-datatable"
   ></b-pagination>
 </div>
</div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import service from "@/services/service";
import axios from "axios";
import store from "@/store.js";

export default {
name: "Table",
props: {
 items: Array,
 caption: {
   type: String,
   default: "Table",
 },
 hover: Boolean,
 striped: Boolean,
 bordered: Boolean,
 small: Boolean,
 fixed: Boolean,
 dark: Boolean,
 items: {
   type: Array,
   required: true,
 },
 listclass:{
     type: Array,
     required: true,
  },
 fields: {
   type: Array,
   required: true,
 },
 meta: {
   required: true,
 },
 btn_show: {
   required: true,
 },
 btn_edit: {
   required: true,
 },
//  btn_deactivate: {
//    required: true,
//  },
 btn_reactivate: {
   required: true,
 },
//  btn_destroy: {
//    required: true,
//  },
 is_uuid: {
   required: true,
 },
//  is_search_by_date: {
//    required: true,
//  },
},
data() {
 return {
   sortBy: null,
   sortDesc: false,
   deleteModal: false,
   selected: null,
   selectID: null,
   inc: 5,
 };
},
watch: {
 sortBy(val) {
   this.$emit("sort", {
     sortBy: this.sortBy,
     sortDesc: this.sortDesc,
   });
 },
 sortDesc(val) {
   this.$emit("sort", {
     sortBy: this.sortBy,
     sortDesc: this.sortDesc,
   });
 },
},
methods: {
 getPhoto(data) {
   if (data) {
     return axios.defaults.baseURL + "/getfile/memberphoto/" + data.filename;
   } else {
     return axios.defaults.baseURL + "/getfile/memberphoto/no_photo.jpg";
   }
 },
 openURL(data) {
  this.$router.push({ name: "Kids Check"});
  let routeData = this.$router.resolve({path: '/ikids/detail',query: {id:data} })
  window.open(routeData.href, '_blank');

 },

 loadPerPage(val) {
   this.$emit("per_page", this.meta.per_page);
 },

 loadIsActive(val) {
   this.$emit("is_active", this.meta.is_active);
 },

 loadStatus(val) {
   this.$emit("status_filter", this.meta.checkin_status);
 },

 loadClassFilter(val) {
   this.$emit("class_filter", this.meta.ikid_class_name)
   const path = window.location.href.split('?')[0]
   let url = path
   if(this.meta.ikid_class_name !== '0'){
    url = path + '?class='+ this.meta.ikid_class_name
   }
   url = url.toLowerCase()
   history.replaceState({}, null, url) ;

  },

 changePage(val) {
   this.$emit("pagination", val);
 },

 search: _.debounce(function(e) {
   this.$emit("search", e.target.value);
 }, 500),

 // ----------------------------
 checkin: function(id) {
   this.$emit("checkin",id);
 },

 present: function(id) {
   this.$emit("present",id);
 },

 checkout: function(id) {
   this.$emit("checkout", id);
 },

 forceCheckout: function(id) {
   this.$emit("forceCheckout", id);
 },

 cancelStatus: function(id, stat) {
   this.$emit("cancelStatus", id, stat);
 },

 forceCancelStatus: function(id, stat) {
   this.$emit("forceCancelStatus", id, stat);
 },

 reprint: function(id) {
   this.$emit("reprint",id);
 },

 // ----------------------------

 inclass: function(id) {
   this.$emit("inclass", id);
 },

 queue: function(id) {
   this.$emit("queue", id);
 },

 checkout: function(id) {
   this.$emit("checkout", id);
 },

 reactivate: function(id) {
   this.$emit("reactivate", id);
 },

 destroy: function(id) {
   this.$emit("destroy", id);
 },

 resetpassword: function(id) {
   this.$emit("resetpassword", id);
 },

 grantwebaccess: function(id) {
   this.$emit("grantwebaccess", id);
 },

 converttomember: function(id) {
   this.$emit("converttomember", id);
 },

 frontEndDateFormat: function(date) {
   return moment(date, "YYYY-MM-DD").format("DD MMMM YYYY");
 },
},
};
</script>
